var config = require("../config.js");
var THREE = require("three");
THREE.BufferGeometryUtils = require("./BufferGeometryUtils")(THREE);
var Rectangle = require("./Rectangle.js")(THREE);
var SkyDome = require("./SkyDome.js");
var shaders = require("../data/shaders.js");
var prefabs = new (require("../data/prefabs.js"))(config);
WebGLRenderingContext.prototype.getProgramInfoLog = function () {
  return "";
};
WebGLRenderingContext.prototype.getShaderInfoLog = function () {
  return "";
};
if (typeof WebGL2RenderingContext != "undefined") {
  WebGL2RenderingContext.prototype.getProgramInfoLog = function () {
    return "";
  };
  WebGL2RenderingContext.prototype.getShaderInfoLog = function () {
    return "";
  };
}
module.exports = function (THREE, J, K, Q, V, W, X, Y) {
  this.ShaderMesh = require("./ShaderMesh.js")(THREE, J, Q, this);
  this.shaderRendering = Y;
  this.ShaderMesh.enabled = !!Y;
  require("./CSS3DRenderer.js")(THREE);
  THREE.ImageUtils.crossOrigin = "";
  var GEOS = require("./geos.js");
  var a0 = new THREE.LoadingManager();
  var a1 = new THREE.OBJLoader(a0);
  var a2 = new THREE.GLTFLoader(a0);
  this.cubeGeo = new THREE.BoxGeometry(1, 1, 1);
  this.getCubeMesh = function () {
    return new THREE.Mesh(this.cubeGeo);
  };
  var a3 = new THREE.PlaneGeometry(1, 1);
  new THREE.CylinderGeometry(
    0.1,
    1,
    1,
    4,
    1,
    false,
    Math.PI / 4,
  ).computeFlatVertexNormals();
  var a4 = new THREE.TextureLoader();
  new THREE.MeshBasicMaterial({
    color: 16777215,
  });
  new THREE.MeshBasicMaterial({
    color: 65280,
  });
  this.invisMat = new THREE.MeshBasicMaterial();
  this.invisMat.visible = false;
  var a5;
  var a6 = {};
  var a7 = {};
  var a8 = {};
  var a9 = {};
  if (this.ShaderMesh.enabled) {
    var aa;
    var ab = 0;
    function ac() {
      if (++ab >= prefabs.textures.length - 1) {
        aa = new Rectangle(ad);
      }
    }
    var ad = {};
    for (var ae = 0; ae < prefabs.textures.length; ae++) {
      if ((a5 = prefabs.textures[ae]).src != "default") {
        ad[a5.src] = a4.load(J.assetsUrl("/textures/" + a5.src + ".png"), ac);
      }
    }
  }
  this.movTextures = [];
  this.movMeshes = [];
  this.pulsMats = [];
  this.rgbMats = [];
  this.liquids = [];
  this.frameMats = [];
  this.pulsVal = 0;
  this.liquidVal = 0;
  var af = this;
  var ag = {};
  this.tmpMouse = new THREE.Vector2();
  this.frustum = new THREE.Frustum();
  var ah = new THREE.Matrix4();
  this.camera = new THREE.PerspectiveCamera(
    0,
    window.innerWidth / window.innerHeight,
    0.1,
    6000,
  );
  Object.freeze(this.camera.scale);
  this.fpsCamera = new THREE.PerspectiveCamera(
    Q.fov,
    window.innerWidth / window.innerHeight,
    0.1,
    200,
  );
  Object.freeze(this.fpsCamera.scale);
  Object.freeze(this.fpsCamera.quaternion);
  Object.freeze(this.fpsCamera.position);
  Object.freeze(this.fpsCamera.rotation);
  this.fpsCamera.layers.set(1);
  this.camera.add(this.fpsCamera);
  this.weaponOffX = 1;
  this.weaponOffY = 1;
  this.weaponOffZ = 1;
  this.weaponADSOffY = 1;
  this.weaponLean = 1;
  this.weaponBob = 1;
  this.liquidUpd = 0;
  this.liquidFreq = 50;
  this.hideADS = 0;
  this.showHands = true;
  this.softShad = false;
  this.highResShad = false;
  this.mapDet = false;
  this.aimAnim = true;
  this.renderDst = 0;
  this.reticleIndex = 0;
  this.lowSpec = false;
  this.noTex = false;
  this.customRatio = null;
  this.aspectRatio = "";
  this.aimFov = true;
  this.adsFovMlt = 1;
  this.objectAnim = true;
  this.rarityAnim = true;
  this.screenShake = true;
  this.textureAnim = true;
  this.weaponShine = true;
  this.lighting = 1;
  this.roundArms = false;
  this.aimRecticle = {
    image: new Image(),
    loaded: false,
    opacity: 0,
    height: 680,
    width: 680,
    display: false,
    custom: false,
  };
  this.aimRecticle.image.onload = () => (this.aimRecticle.loaded = true);
  this.aimRecticle.image.src = J.assetsUrl("/textures/recticle.png");
  this.aimDot = {
    image: new Image(),
    loaded: false,
    opacity: 0,
    width: 20,
    height: 20,
    display: false,
    custom: false,
    savedCustom: "",
  };
  this.aimDot.image.onload = () => (this.aimDot.loaded = true);
  this.aimDot.image.src = J.assetsUrl("/textures/reticles/reticle_0.png");
  this.missingTexture = new Image();
  this.missingTexture.src =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAgMAAAAP2OW3AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAxQTFRF/wDbAAAAAAAA/wDbC5gN/AAAAAR0Uk5T/P/9/02rixUAAAAMSURBVHicYxBg2AAAAOQAwSeo6FcAAAAASUVORK5CYII=";
  this.init = function (at, au) {
    this.clearPendingMeshes();
    this.scene = new THREE.Scene();
    this.backgroundScene = new THREE.Scene();
    this.skyDome = null;
    if (at.skyDome && au && au.skyCol == null) {
      this.skyDome = SkyDome.fromConfig(this, at);
      this.backgroundScene.add(this.skyDome);
    }
    module.exports.initScene.apply(this, [at, au]);
    this.initShaders();
  };
  this.getRes = function () {
    var at = J.isString(this.aspectRatio) ? this.aspectRatio.split("x") : [];
    return (
      (parseInt(at[0]) || window.innerWidth) /
      (parseInt(at[1]) || window.innerHeight)
    );
  };
  var ai = 0;
  this.flash = function (at, au) {
    V.showFlash = true;
    V.flashX = at;
    V.flashY = 1 - au;
    ai = 1;
  };
  this.updateLightMap = function (at) {
    if (this.skyLight) {
      this.skyLight.shadow.camera.right = at.shadWidth;
      this.skyLight.shadow.camera.left = -at.shadWidth;
      this.skyLight.shadow.camera.top = at.shadLength;
      this.skyLight.shadow.camera.bottom = -at.shadLength;
    }
  };
  if (!X) {
    var aj = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
    this.renderer = new THREE[aj ? "WebGL1Renderer" : "WebGLRenderer"]({
      powerPreference: "high-performance",
      antialias: getSavedVal("kro_setngss_antiAlias") == "true",
    });
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.autoUpdate = false;
    this.renderer.shadowMap.type = THREE.BasicShadowMap;
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.autoClear = false;
    document.body.appendChild(this.renderer.domElement);
    if (this.renderer.capabilities.isWebGL2 === false) {
      this.shaderRendering = false;
      this.ShaderMesh.enabled = false;
    }
  }
  this.postprocessing = {
    composer: null,
    enabled: true,
    active: false,
    shader: THREE.CopyShader,
  };
  this.initShaders = function () {
    if (this.skyDome) {
      var at = new THREE.RenderPass(this.backgroundScene, this.camera);
      at.layer = 0;
      at.clear = false;
    }
    var au = new THREE.RenderPass(this.scene, this.camera);
    if (this.skyDome) {
      au.layer = 0;
    }
    if (this.skyDome) {
      au.clear = false;
    }
    var av = new THREE.RenderPass(this.scene, this.camera);
    av.layer = 2;
    av.clear = false;
    var aw = new THREE.RenderPass(this.scene, this.fpsCamera);
    aw.clear = false;
    aw.clearDepth = true;
    var ax = new THREE.ShaderPass(this.postprocessing.shader);
    this.postprocessing.composer = new THREE.EffectComposer(
      this.renderer,
      undefined,
      this,
    );
    if (this.skyDome) {
      this.postprocessing.composer.addPass(at);
    }
    this.postprocessing.composer.addPass(au);
    this.postprocessing.composer.addPass(av);
    this.postprocessing.composer.addPass(aw);
    this.postprocessing.composer.addPass(ax);
    this.resizeShaders();
  };
  this.shaderInputs = [];
  this.updateShaderPass = function (at) {
    this.shaderInputs.length = 0;
    try {
      at.uniforms.resolution &&= {
        value: new THREE.Vector2(window.innerWidth, window.innerHeight),
      };
      if (at.uniforms.tDiffuse == null) {
        at.uniforms.tDiffuse =
          this.postprocessing.composer.renderTarget.texture;
      }
      for (var au in at.uniforms) {
        if ((a5 = at.uniforms[au]).user) {
          if (a5.toggle) {
            this.shaderInputs.push({
              name: au,
              toggle: true,
            });
          } else {
            this.shaderInputs.push({
              name: au,
              min: parseFloat(a5.min) || 0,
              max: parseFloat(a5.max) || 0,
              step: parseFloat(a5.step) || 0,
            });
          }
        }
      }
      this.postprocessing.shader = {
        defines: Object.assign({}, at.defines),
        fragmentShader: at.fragmentShader,
        uniforms: at.uniforms,
        vertexShader: at.vertexShader,
      };
      if (!this.postprocessing.composer) {
        this.postprocessing.active = true;
        return;
      }
      var av = new THREE.ShaderPass(this.postprocessing.shader);
    } catch (aw) {
      return;
    }
    this.postprocessing.composer.replacePass(av, this.skyDome ? 4 : 3);
    this.postprocessing.active = true;
  };
  this.resizeShaders = function () {
    if (this.postprocessing.composer) {
      var at = this.renderer.getPixelRatio();
      var au = Math.floor(window.innerWidth / at) || 1;
      var av = Math.floor(window.innerHeight / at) || 1;
      this.postprocessing.composer.setSize(au, av);
    }
  };
  this.shadows = true;
  this.updateShadowMap = function () {
    if (this.shadows) {
      this.renderer.shadowMap.needsUpdate = true;
    }
  };
  this.toggleShadQual = function (at) {
    this.renderer.shadowMap.type = at
      ? THREE.PCFSoftShadowMap
      : THREE.BasicShadowMap;
    if (this.skyLight) {
      this.renderer.setRenderTarget(this.skyLight.shadow.map);
      this.renderer.clear();
      this.renderer.setRenderTarget(null);
    }
    this.updateShadowMap();
  };
  this.toggleShadowMap = function (at) {
    if (at) {
      this.shadows = true;
      this.updateShadowMap();
    } else {
      this.shadows = false;
      if (this.skyLight) {
        this.renderer.setRenderTarget(this.skyLight.shadow.map);
        this.renderer.clear();
        this.renderer.setRenderTarget(null);
      }
    }
  };
  this.dynamicShadows = false;
  this.toggleShadowAuto = function (at) {
    this.dynamicShadows = at;
    this.renderer.shadowMap.autoUpdate = at;
    this.updateShadowMap();
  };
  this.zoomVal = 1;
  this.zoom = function (at) {
    if (!this.aimFov) {
      at = 1;
    }
    this.zoomVal = at;
    this.updateCamFOV();
    this.fpsCamera.fov = this.fpsFov / at;
    this.fpsCamera.updateProjectionMatrix();
  };
  this.fovMult = function (at) {
    if (this.fovMlt != at) {
      this.fovMlt = at;
      this.updateCamFOV();
    }
  };
  this.setFPSFov = function (at) {
    this.fpsFov = at;
    this.fpsCamera.fov = at;
    this.fpsCamera.updateProjectionMatrix();
  };
  this.setFPSFov(Q.fov);
  this.fovMlt = 1;
  this.updateCamFOV = function () {
    this.camera.fov = (this.fov / this.zoomVal) * this.fovMlt;
    this.camera.updateProjectionMatrix();
  };
  this.setFov = function (at) {
    this.fov = at;
    this.updateCamFOV();
  };
  this.setFov(Q.fov);
  this.resize = function () {
    this.camera.aspect = this.getRes();
    this.camera.updateProjectionMatrix();
    this.fpsCamera.aspect = this.getRes();
    this.fpsCamera.updateProjectionMatrix();
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.resizeShaders();
  };
  this.resMltV = 1;
  this.setResMlt = function (at) {
    this.resMltV = at;
    this.renderer.setPixelRatio(window.devicePixelRatio * this.resMltV);
    this.renderer.setSize(window.innerWidth, window.innerHeight);
  };
  this.updateFrustum = function () {
    this.frustum.setFromProjectionMatrix(
      ah.multiplyMatrices(
        this.camera.projectionMatrix,
        this.camera.matrixWorldInverse,
      ),
    );
  };
  var ak = 0;
  var al = 0;
  this.shakeY = 0;
  this.shakeX = 0;
  this.updateShake = function (at) {
    if (al && this.screenShake) {
      al *= Math.pow(0.99, at);
      ak += J.randFloat(-Math.PI, Math.PI);
      this.shakeX = Math.sin(ak) * al;
      this.shakeY = Math.cos(ak) * al;
      if (al <= 0.01) {
        al = 0;
        this.shakeY = this.shakeX = 0;
      }
    }
  };
  this.shake = function (at) {
    al = at;
  };
  this.render = function (at, au) {
    if (this.scene || au) {
      if (this.textureAnim) {
        for (var av = 0; av < this.movTextures.length; ++av) {
          if ((a5 = this.movTextures[av]).tex.offset) {
            a5.tex.offset[a5.movD == 0 ? "x" : "y"] += a5.mov * at;
          }
        }
        for (av = 0; av < this.movMeshes.length; ++av) {
          if ((a5 = this.movMeshes[av]) && a5.mesh) {
            a5.mesh["rotate" + a5.axis](a5.tim * at);
          }
        }
        this.pulsVal += at * 0.003;
        var aw;
        for (av = 0; av < this.pulsMats.length; ++av) {
          aw = (Math.sin(this.pulsVal) / 2 + 0.5) * 1.5;
          aw += this.pulsMats[av].minGlo || 0;
          this.pulsMats[av].mat.emissiveIntensity = aw;
        }
        for (av = 0; av < this.frameMats.length; ++av) {
          (a5 = this.frameMats[av]).dur -= at;
          if (a5.dur <= 0) {
            a5.dur = a5.orgDur;
            a5.cur++;
            if (a5.cur >= a5.num) {
              a5.cur = 0;
            }
            if (a5.mat.map) {
              a5.mat.map.offset.x = (a5.cur % a5.num) / a5.num;
            }
          }
        }
        for (av = 0; av < this.rgbMats.length; ++av) {
          (a5 = this.rgbMats[av]).dlt += at * a5.mlt;
          if (a5.dlt >= 360) {
            a5.dlt = 0;
          }
          if (a5.mat && a5.mat.type != "MeshBasicMaterial") {
            a5.mat[a5.type ? "color" : "emissive"] = new THREE.Color(
              J.hexFromHue(Math.round(a5.dlt)),
            );
          }
        }
      }
      if (
        this.objectAnim &&
        ((this.liquidVal += at * 0.003),
        (this.liquidUpd -= at),
        this.liquidUpd <= 0)
      ) {
        this.liquidUpd = this.liquidFreq;
        for (av = 0; av < this.liquids.length; ++av) {
          a5 = this.liquids[av];
          for (var ax = 0; ax < a5.mesh.geometry.vertices.length; ax++) {
            a5.mesh.geometry.vertices[ax].z =
              a5.hght * Math.sin(ax / 5 + (this.liquidVal * a5.spd) / 4);
          }
          a5.mesh.geometry.verticesNeedUpdate = true;
          a5.mesh.geometry.computeVertexNormals();
        }
      }
      if (!au) {
        this.renderer.clear();
        this.camera.layers.set(0);
        if (this.skyDome) {
          this.camera.getWorldPosition(this.skyDome.position);
        }
        if (
          this.postprocessing.composer &&
          this.postprocessing.enabled &&
          this.postprocessing.active
        ) {
          this.postprocessing.composer.render(at);
        } else {
          if (this.skyDome) {
            this.renderer.render(this.backgroundScene, this.camera);
            this.renderer.clearDepth();
          }
          this.renderer.render(this.scene, this.camera);
          this.camera.layers.set(2);
          this.renderer.render(this.scene, this.camera);
          this.renderer.clearDepth();
          this.renderer.render(this.scene, this.fpsCamera);
        }
        if (V.showFlash) {
          if (ai <= 0) {
            ai = 0;
            V.showFlash = false;
          }
          ai -= at;
        }
        this.updateShake(at);
      }
    }
  };
  this.updateTexture = function (at, au, av) {
    av = av || {};
    var aw = 0;
    for (var ax in a7) {
      if (!ax.includes("sad")) {
        if (ax.substring(0, at.length + 2) == at + "mt") {
          aw++;
          a7[ax].image = au;
          a7[ax].needsUpdate = true;
        }
      }
    }
    if (!aw) {
      var ay = new THREE.Texture(au);
      a8[at] = ay;
      a8[at].needsUpdate = true;
    }
  };
  this.loadTexture = function (at, au, av, aw) {
    var ax =
      au +
      ((av = av || {}).movT == null ? "mt" : "mt" + av.movT) +
      (av.movD == null ? "md" : av.movD) +
      (av.fontSize || "fs") +
      (av.fcolr || "fc") +
      (av.bcolr || "bc") +
      (av.noBVis || "bv") +
      (av.text || "txt") +
      (av.tAlign || "ta") +
      (av.showAd ? "sad" : "nad") +
      (av.tId || "ctx") +
      (av.texOffX || "tox") +
      (av.texOffY || "toy") +
      (av.normal || "n") +
      (av.spec || "spec") +
      (av.asset || "as") +
      (av.umid || "umid");
    if (a7[ax]) {
      if (a7[ax].mats) {
        a7[ax].mats.push({
          t: aw,
          m: at,
        });
      } else {
        at[aw || "map"] = a7[ax];
        if (av.frames && at.map.repeat.x == 1) {
          at.map.repeat.x = 1 / av.frames;
        }
        at.needsUpdate = true;
      }
    } else {
      a7[ax] = {
        mats: [
          {
            t: aw,
            m: at,
          },
        ],
      };
      if (a8[au]) {
        (az = a8[au]).wrapS = THREE.RepeatWrapping;
        az.wrapT = THREE.RepeatWrapping;
        az.repeat.set(
          av.frames ? 1 / av.frames : av.repeatX || 1,
          av.repeatY || 1,
        );
        az.minFilter = av.tFilter || THREE.NearestFilter;
        az.magFilter = av.tFilter || THREE.NearestFilter;
        az.offset.x = av.texOffX || 0;
        az.offset.y = av.texOffY || 0;
        az.needsUpdate = true;
        for (var ay = 0; ay < a7[ax].mats.length; ++ay) {
          a7[ax].mats[ay].m[a7[ax].mats[ay].t || "map"] = az;
          a7[ax].mats[ay].m.needsUpdate = true;
        }
        a7[ax] = az;
        if (av.movT) {
          this.movTextures.push({
            tex: az,
            mov: av.movT,
            movD: av.movD || 0,
          });
        }
      } else if (aw && av.noEmisTex);
      else if (av.canvas) {
        (az = new THREE.Texture(av.canvas)).wrapS = THREE.RepeatWrapping;
        az.wrapT = THREE.RepeatWrapping;
        az.repeat.set(av.repeatX || 1, av.repeatY || 1);
        az.minFilter = av.tFilter || THREE.NearestFilter;
        az.magFilter = av.tFilter || THREE.NearestFilter;
        az.needsUpdate = true;
        for (ay = 0; ay < a7[ax].mats.length; ++ay) {
          a7[ax].mats[ay].m[a7[ax].mats[ay].t || "map"] = az;
          a7[ax].mats[ay].m.needsUpdate = true;
        }
        a7[ax] = az;
        if (av.movT) {
          this.movTextures.push({
            tex: az,
            mov: av.movT,
            movD: av.movD || 0,
          });
        }
      } else if (typeof au == "string" && au.includes("custom_")) {
        if (!aw) {
          var az;
          (az = new THREE.Texture(af.missingTexture)).wrapS =
            THREE.RepeatWrapping;
          az.wrapT = THREE.RepeatWrapping;
          az.repeat.set(
            av.frames ? 1 / av.frames : av.repeatX || 1,
            av.repeatY || 1,
          );
          az.minFilter = av.tFilter || THREE.NearestFilter;
          az.magFilter = av.tFilter || THREE.NearestFilter;
          az.offset.x = av.texOffX || 0;
          az.offset.y = av.texOffY || 0;
          az.needsUpdate = true;
          for (ay = 0; ay < a7[ax].mats.length; ++ay) {
            a7[ax].mats[ay].m[a7[ax].mats[ay].t || "map"] = az;
            a7[ax].mats[ay].m.needsUpdate = true;
          }
          a7[ax] = az;
          if (av.movT) {
            this.movTextures.push({
              tex: az,
              mov: av.movT,
              movD: av.movD || 0,
            });
          }
        }
      } else if (typeof au == "string" && !au.includes("default")) {
        a4.load(
          av.asset
            ? J.userAssetsUrl(au + ".png")
            : J.assetsUrl("/textures/" + au + ".png", false, av.local),
          (aA) => {
            aA.wrapS = THREE.RepeatWrapping;
            aA.wrapT = THREE.RepeatWrapping;
            aA.repeat.set(
              av.frames ? 1 / av.frames : av.repeatX || 1,
              av.repeatY || 1,
            );
            aA.minFilter = av.tFilter || THREE.NearestFilter;
            aA.magFilter = av.tFilter || THREE.NearestFilter;
            aA.offset.x = av.texOffX || 0;
            aA.offset.y = av.texOffY || 0;
            aA.needsUpdate = true;
            for (var aB = 0; aB < a7[ax].mats.length; ++aB) {
              a7[ax].mats[aB].m[a7[ax].mats[aB].t || "map"] = aA;
              a7[ax].mats[aB].m.needsUpdate = true;
            }
            a7[ax] = aA;
            if (av.movT) {
              this.movTextures.push({
                tex: aA,
                mov: av.movT,
                movD: av.movD || 0,
              });
            }
          },
          undefined,
          function () {
            if (!aw) {
              var aA = new THREE.Texture(this.missingTexture);
              aA.wrapS = THREE.RepeatWrapping;
              aA.wrapT = THREE.RepeatWrapping;
              aA.repeat.set(
                av.frames ? 1 / av.frames : av.repeatX || 1,
                av.repeatY || 1,
              );
              aA.minFilter = av.tFilter || THREE.NearestFilter;
              aA.magFilter = av.tFilter || THREE.NearestFilter;
              aA.offset.x = av.texOffX || 0;
              aA.offset.y = av.texOffY || 0;
              aA.needsUpdate = true;
              for (var aB = 0; aB < a7[ax].mats.length; ++aB) {
                a7[ax].mats[aB].m[a7[ax].mats[aB].t || "map"] = aA;
                a7[ax].mats[aB].m.needsUpdate = true;
              }
              a7[ax] = aA;
              if (av.movT) {
                this.movTextures.push({
                  tex: aA,
                  mov: av.movT,
                  movD: av.movD || 0,
                });
              }
            }
          },
        );
      }
    }
    return at;
  };
  this.getMat = function (at, au) {
    if (af.lighting == 0 && au.mat != THREE.SpriteMaterial) {
      au.mat = THREE.MeshBasicMaterial;
    }
    if (af.lighting == 2 && au.mat != THREE.SpriteMaterial) {
      au.mat = THREE.MeshPhongMaterial;
    }
    var av =
      ((au && au.texSrc) || at) +
      (au
        ? (au.rotation || "x") +
          (au.noFog || "y") +
          (au.umid || "umid") +
          (au.opacity || "z") +
          (au.color || "b") +
          (au.mat ? "ma" : "nm") +
          (au.ao || "a") +
          (au.emissive || "e") +
          (au.glowText || "g") +
          (au.movT == null ? "mt" : au.movT) +
          (au.movD == null ? "md" : au.movD) +
          (au.canvas == null ? "" : "canvas") +
          (au.pulsT == null ? "npt" : "pt" + au.pulsT) +
          (au.normal || "n") +
          (au.spec || "spec") +
          (au.alph || "alph") +
          (au.asset || "as") +
          +(au.frames == null ? "nfr" : "fr" + au.frames) +
          (au.frameT == null ? "nfrt" : "frt" + au.frameT) +
          (au.rAnim == null ? "nra" : "ra" + au.rAnim) +
          (au.rAnimA == null ? "nraa" : "raa" + au.rAnimA) +
          (au.depthWrite == null ? "d" : au.depthWrite) +
          (au.fontSize || "fs") +
          (au.fcolr || "fc") +
          (au.bcolr || "bc") +
          (au.noBVis || "bv") +
          (au.text || "txt") +
          (au.tAlign || "ta") +
          (au.showAd ? "sad" : "nad") +
          (au.rgb ? "rgb" : "nrgb") +
          (au.rgbS ? "rgbS" : "nrgbS") +
          (au.rgbT || "rgbT") +
          (au.texOffX || "tox") +
          (au.texOffY || "toy") +
          (au.itemID || "itemID") +
          (au.wireframe ? "wf" : "nwf")
        : "");
    var aw = a6[av];
    if (!aw) {
      if ((au = au || {}).shaderId != null && shaders[au.shaderId]) {
        aw = new THREE.ShaderToyMaterial(shaders[au.shaderId].code, au);
        if (au.side != null) {
          aw.side = au.side;
        }
      } else {
        aw = new (au.mat ? au.mat : THREE.StrippedLambertMaterial)(au);
      }
      if (au && au.rgb) {
        aw.dithering = true;
      }
      if (au.canvas) {
        this.loadTexture(aw, av, au);
      }
      if (at && at != "default") {
        this.loadTexture(aw, au.texSrc || at, au);
      }
      if (au && au.emissive) {
        this.loadTexture(
          aw,
          ((au.glowText && au.texSrc) || at) + (au.sameGlow ? "" : "_e"),
          au,
          "emissiveMap",
        );
      }
      if (au && au.ao) {
        this.loadTexture(aw, at + "_ao", au, "aoMap");
        aw.aoMapIntensity = 1.3;
      }
      if (au && au.normal) {
        this.loadTexture(aw, at + "_n", au, "normalMap");
      }
      if (au && au.spec) {
        this.loadTexture(aw, at + "_s", au, "specularMap");
      }
      if (au && au.alph) {
        this.loadTexture(aw, at + "_a", au, "alphaMap");
      }
      if (at == "default" || (au && au.rgb && !au.rgbT)) {
        aw.vertexColors = THREE.VertexColors;
      }
      if (au && au.noFog) {
        aw.fog = false;
      }
      if (aw.hasOwnProperty("shading")) {
        aw.shading = THREE.SmoothShading;
      }
      a6[av] = aw;
      if (au.pulsT) {
        this.pulsMats.push({
          mat: aw,
          pul: au.pulsT,
          minGlo: au.minGlo,
        });
      }
      if (
        au.frames &&
        au.frameT &&
        !au.noAutoAnim &&
        !this.frameMats.find((ax) => ax.src == ((au && au.texSrc) || at))
      ) {
        this.frameMats.push({
          mat: aw,
          src: (au && au.texSrc) || at,
          num: au.frames,
          cur: 0,
          dur: au.frameT,
          orgDur: au.frameT,
        });
      }
      if (au.rgb) {
        this.rgbMats.push({
          mat: aw,
          mlt: au.rgbS || 0.3,
          type: au.rgbT || 0,
          dlt: 0,
        });
      }
    }
    return aw;
  };
  this.genColorCube = function (at, au, av, aw, ax, ay) {
    var az = (ay = ay || {}).us ? "us" : "ns";
    for (var aA = 0; aA < aw.length; ++aA) {
      for (var aB = 0; aB < aw[aA].length; ++aB) {
        az += aw[aA][aB] + "_";
      }
      az += "|";
    }
    var aC = a9[az];
    if (!aC) {
      aC = new THREE.Geometry();
      var aD = 0.5 + (ax || 0);
      for (aA = 0; aA < aw.length; ++aA) {
        var aE = aw[aA][1];
        var aF = aw[aA][2] || 1;
        if (ay.us) {
          if (ay.cyl) {
            aG = GEOS.generateCylinder({
              colr: aw[aA][0],
              fAmb: aw[aA][4],
              amb: aw[aA][3],
            });
            aF /= 2;
          } else {
            aG = GEOS.generateCube([1, 1, 1, 1, 1, 1], 1, 1, 1, {
              colr: aw[aA][0],
              fAmb: aw[aA][4],
              amb: aw[aA][3],
            });
          }
          (aH = new THREE.Mesh(aG)).scale.set(aF, aE, aF);
          this.moveMesh(aH, 0, aD - aE, 0);
        } else {
          var aG = new THREE.BoxGeometry(aF, aE, aF);
          GEOS.colorize(aG, aw[aA][0]);
          aH = new THREE.Mesh(aG);
          this.moveMesh(aH, 0, aD - aE / 2, 0);
        }
        this.merge(aC, aH);
        aD -= aE;
      }
      a9[az] = aC;
    }
    var aH = new THREE.Mesh(aC, this.getMat(ay.src || "default", ay));
    this.scaleMesh(aH, at, au, av);
    return aH;
  };
  var am = {};
  this.genLeg = function (at, au, av, aw) {
    (aw = aw || {}).us = aw.det;
    var ax = Q.legScale;
    var ay = null;
    if (aw.crouch) {
      var az =
        (aw.texSrc || "default") +
        (au + "-") +
        av +
        "-" +
        (aw.crouch || "") +
        "-" +
        (aw.rgb ? "rgb" : "") +
        (aw.movT == null ? "mt" : aw.movT) +
        (aw.movD == null ? "md" : aw.movD);
      if (!(ay = am[az])) {
        var aA = Q.legHeight / 2;
        var aB = ax / 2;
        var aC = [0.5, 2];
        var aD = this.genColorCube(ax, aA, ax, [[au, 1]], 0, {
          us: aw.det,
        });
        this.moveMesh(
          aD,
          0,
          (-aA / 2) * Math.cos(aC[1]),
          (-aA / 2) * Math.sin(aC[1]),
        );
        this.rotateMesh(aD, 0, aC[1], 0);
        var aE = Math.sqrt(
          aB * aB + aB * aB - aB * 2 * aB * Math.cos(aC[0] - aC[1]),
        );
        var aF = Math.sqrt(aB * aB - (aE / 2) * (aE / 2)) * 2;
        var aG = this.genColorCube(ax, aE, aF, [[au, 1]], 0, {
          us: aw.det,
        });
        this.moveMesh(aG, 0, -aA * Math.cos(aC[1]), -aA * Math.sin(aC[1]));
        this.rotateMesh(aG, 0, (aC[1] + aC[0]) / 2, 0);
        var aH = this.genColorCube(
          ax,
          aA,
          ax,
          [
            [au, 0.5, 1, 0.8],
            [av, 0.5],
          ],
          0,
          {
            us: aw.det,
          },
        );
        this.moveMesh(
          aH,
          0,
          -aA * Math.cos(aC[1]) - (aA / 2) * Math.cos(aC[0]),
          -aA * Math.sin(aC[1]) - (aA / 2) * Math.sin(aC[0]),
        );
        this.rotateMesh(aH, 0, aC[0], 0);
        ay = new THREE.Geometry();
        this.merge(ay, aD);
        this.merge(ay, aG);
        this.merge(ay, aH);
        am[az] = ay;
      }
      ay = THREE.BufferGeometryUtils.mergeVertices(
        new THREE.BufferGeometry().fromGeometry(ay),
      );
      ay = new THREE.Mesh(ay, this.getMat(aw.texSrc || "default", aw));
      this.moveMesh(
        ay,
        (Q.legScale / 2) * (at ? -1 : 1),
        Q.legHeight - Q.crouchDst + 0.5,
        0,
      );
    } else {
      ay = this.genColorCube(
        ax,
        Q.legHeight,
        ax,
        [
          [au, 0.75, 1],
          [av, 0.25],
        ],
        -0.5,
        aw,
      );
      this.moveMesh(ay, (Q.legScale / 2) * (at ? -1 : 1), Q.legHeight, 0);
    }
    ay.receiveShadow = true;
    ay.castShadow = this.dynamicShadows;
    ay.noGreen = true;
    return ay;
  };
  var an = {};
  this.genBody = function (at, au) {
    var av =
      ((au = au || {}).texSrc || "default") +
      (au.shirtCol + "-") +
      au.pantsCol +
      "-" +
      au.hairCol +
      "-" +
      au.skinCol +
      "-" +
      (au.rgb ? "rgb" : "") +
      "-" +
      (au.noHead ? "nh" : "") +
      (au.movT == null ? "mt" : au.movT) +
      (au.movD == null ? "md" : au.movD);
    var aw = an[av];
    if (!aw) {
      aw = new THREE.Geometry();
      var ax = Q.playerHeight - Q.headScale - Q.legHeight;
      var ay = this.genColorCube(
        Q.chestWidth,
        ax,
        Q.chestScale,
        [
          [au.shirtCol, 0.8, 1, 0.8],
          [au.pantsCol, 0.2, 1.05],
        ],
        0,
        {
          us: at,
        },
      );
      this.moveMesh(ay, 0, ax / 2, 0);
      this.merge(aw, ay);
      if (!au.noHead) {
        var az = this.genColorCube(
          Q.headScale,
          Q.headScale,
          Q.headScale,
          [
            [au.hairCol, 0.2, 1, 0.6],
            [au.skinCol, 0.8],
          ],
          0,
          {
            us: at,
          },
        );
        this.moveMesh(az, 0, Q.playerHeight - Q.headScale / 2 - Q.legHeight, 0);
        this.merge(aw, az);
      }
      aw = THREE.BufferGeometryUtils.mergeVertices(
        new THREE.BufferGeometry().fromGeometry(aw),
      );
      an[av] = aw;
    }
    var aA = new THREE.Mesh(aw, this.getMat(au.texSrc || "default", au));
    aA.receiveShadow = true;
    aA.castShadow = this.dynamicShadows;
    aA.noGreen = true;
    return aA;
  };
  var ao = {};
  this.genArms = function (at, au, av, aw) {
    var ax =
      ((aw = aw || {}).texSrc || "default") +
      at.name +
      "-" +
      aw.shirtCol +
      "-" +
      aw.sleeveCol +
      "-" +
      aw.skinCol +
      "-" +
      aw.leftHand +
      "-" +
      av +
      "-" +
      (au || 0) +
      "-" +
      (aw.rgb ? "rgb" : "") +
      (aw.movT == null ? "mt" : aw.movT) +
      (aw.movD == null ? "md" : aw.movD) +
      (aw.armS ? aw.armS : "");
    var ay = ao[ax];
    if (!ay) {
      ay = new THREE.Geometry();
      var az =
        (-Q.chestWidth + Q.armScale / 2 - Q.armInset) *
        (av ? at.holdW || 0.4 : 1);
      if (!au || au == 1) {
        this.merge(
          ay,
          this.genArm(
            az,
            Q.armOff,
            at,
            !aw.leftHand,
            aw.shirtCol,
            aw.sleeveCol,
            aw.skinCol,
            av,
            aw,
          ),
        );
      }
      if (!au || au == 2) {
        this.merge(
          ay,
          this.genArm(
            -az,
            Q.armOff,
            at,
            aw.leftHand,
            aw.shirtCol,
            aw.sleeveCol,
            aw.skinCol,
            av,
            aw,
          ),
        );
      }
      ay = THREE.BufferGeometryUtils.mergeVertices(
        new THREE.BufferGeometry().fromGeometry(ay),
      );
      ao[ax] = ay;
    }
    (ay = new THREE.Mesh(
      ay,
      this.getMat(aw.texSrc || "default", aw),
    )).position.z += (av && at.hDstOff) || 0;
    ay.noGreen = true;
    ay.receiveShadow = true;
    ay.castShadow = !av && this.highResShad;
    return ay;
  };
  this.genArm = function (at, au, av, aw, ax, ay, az, aA, aB) {
    var aC = aw ? av.leftHoldY : av.rightHoldY;
    var aD = aw ? av.leftHoldZ : av.rightHoldZ;
    var aE = aB.leftHand ? -1 : 1;
    aD += (aA && av.hDstOff) || 0;
    var aF = (aw ? av.leftHoldX || 0 : av.rightHoldX || 0) * aE;
    var aG = Q.armScale * (aA ? 0.68 : 1) * (aB.armS || 1);
    var aH = Math.min(
      Q.uArmLength + Q.lArmLength - 0.01,
      J.getD3D(
        at,
        au,
        0,
        (av.xOff * aE - aF) * (aw && av.akimbo ? -1 : 1),
        av.yOff + aC,
        av.zOff - aD,
      ),
    );
    var aI = J.getAnglesSSS(aH, Q.uArmLength, Q.lArmLength);
    var aJ = Math.PI / 2;
    if (!aA) {
      var aK = this.genColorCube(aG, Q.uArmLength, aG, [[ax, 1]], 0, {
        us: aA,
        cyl: af.roundArms,
      });
      this.moveMesh(
        aK,
        0,
        (-Q.uArmLength / 2) * Math.cos(aJ),
        (-Q.uArmLength / 2) * Math.sin(aJ),
      );
      this.rotateMesh(aK, 0, aJ, 0);
      var aL = aG / 2;
      var aM = Math.sqrt(
        aL * aL +
          aL * aL -
          aL * 2 * aL * Math.cos(Math.PI + aI[0] + Math.PI / 2),
      );
      var aN = Math.sqrt(aL * aL - (aM / 2) * (aM / 2)) * 2;
      var aO = this.genColorCube(aG, aM, aN, [[ax, 1]], 0, {
        us: aA,
        cyl: af.roundArms,
      });
      this.moveMesh(
        aO,
        0,
        -Q.uArmLength * Math.cos(aJ),
        -Q.uArmLength * Math.sin(aJ),
      );
      this.rotateMesh(aO, 0, (aJ + aI[0]) / 2, 0);
    }
    var aP = this.genColorCube(
      aG,
      Q.lArmLength,
      aG,
      [
        [ax, 0.65, 1, 0.6],
        [ay, 0.15, 1.1],
        [az, 0.2, 1, 0.5, true],
      ],
      0,
      {
        us: aA,
        cyl: af.roundArms,
      },
    );
    var aQ = Q.lArmLength / 2;
    this.moveMesh(
      aP,
      0,
      -Q.uArmLength * Math.cos(aJ) - aQ * Math.cos(aI[0]),
      -Q.uArmLength * Math.sin(aJ) - aQ * Math.sin(aI[0]),
    );
    this.rotateMesh(aP, 0, aI[0], 0);
    var aR = new THREE.Geometry();
    if (aA) {
      var aS = this.genColorCube(aG, 20, aG, [[ax, 1]], 0, {
        us: aA,
        cyl: af.roundArms,
      });
      this.moveMesh(
        aS,
        0,
        -Q.uArmLength * Math.cos(aJ) - Math.cos(aI[0]) * -10,
        -Q.uArmLength * Math.sin(aJ) - Math.sin(aI[0]) * -10,
      );
      this.rotateMesh(aS, 0, aI[0], 0);
      this.merge(aR, aS);
    } else {
      this.merge(aR, aK);
      this.merge(aR, aO);
    }
    this.merge(aR, aP);
    aR = new THREE.Mesh(aR);
    this.moveMesh(aR, at - av.xOff * aE, au - av.yOff, -av.zOff);
    aR.rotation.order = "YXZ";
    aR.rotation.x = -aI[1] - J.direction2D(0, au, av.zOff - aD, av.yOff + aC);
    aR.rotation.y =
      J.direction2D(
        -at,
        0,
        (aw && av.akimbo ? 1 : -1) * (av.xOff * aE - aF),
        av.zOff - aD,
      ) -
      Math.PI / 2;
    return aR;
  };
  this.addCube = function (at, au, av, aw, ax, ay, az, aA) {
    aA = aA || {};
    if (
      this.ShaderMesh.enabled &&
      (!aA.src || aA.src.includes("default") || ad[aA.src])
    ) {
      var aB = this.ShaderMesh.addCube(at, au, av, aw, ax, ay, az, aA);
    } else {
      aB = new THREE.Mesh(GEOS.generateCube(az, aw, ax, ay, aA));
      this.moveMesh(aB, at, au, av);
      aB.rotation.set(aA.yR || 0, aA.xR || 0, aA.zR || 0);
      aB.scale.set(aw, ax, ay);
      if (this.noTex && !aA.forceTex) {
        aA.src = "default";
      }
      if (!aA.autoMatrix) {
        aB.matrixAutoUpdate = false;
      }
      if (aA.src && !aA.noGroup) {
        this.meshGroup(aB, aA);
      } else {
        this.add(aB, aA);
      }
    }
    return aB;
  };
  this.addPointLight = function (at, au, av, aw) {
    if (af.lighting == 2) {
      aw = aw || {};
      var ax = new THREE.PointLight(
        aw.colr || "#f2f8fc",
        aw.intensity || 1,
        aw.distance || 0,
        aw.decay || 1,
      );
      ax.position.set(at, au, av);
      this.add(ax);
    }
  };
  this.addCone = function (at, au, av, aw, ax, ay, az) {
    if (!this.noTex) {
      az = az || {};
      var aA = new THREE.Mesh(GEOS.generateCone(ax, az));
      var aB = Math.min(aw, ay) / 2;
      aA.scale.set(aB, ax, aB);
      this.moveMesh(aA, at, au, av);
      aA.rotation.set(az.yR || 0, az.xR || 0, az.zR || 0);
      if (az.src && !az.noGroup) {
        this.meshGroup(aA, az);
      } else {
        this.add(aA, az);
      }
      return aA;
    }
  };
  this.addCylinder = function (at, au, av, aw, ax, ay, az) {
    if (!this.noTex) {
      az = az || {};
      var aA = new THREE.Mesh(GEOS.generateCylinder(az));
      var aB = Math.min(aw, ay) / 2;
      aA.scale.set(aB, ax, aB);
      this.moveMesh(aA, at, au, av);
      aA.rotation.set(az.yR || 0, az.xR || 0, az.zR || 0);
      if (az.rAnim) {
        this.movMeshes.push({
          mesh: aA,
          tim: az.rAnim,
          axis: (az.rAnimA || "y").toUpperCase(),
        });
      }
      if (az.src && !az.noGroup) {
        this.meshGroup(aA, az);
      } else {
        this.add(aA, az);
      }
      return aA;
    }
  };
  this.addSphere = function (at, au, av, aw, ax, ay, az) {
    az = az || {};
    var aA = new THREE.Mesh(GEOS.generateSphere(aw, ax, ay, az));
    this.moveMesh(aA, at, au + ax / 2, av);
    aA.rotation.set(az.yR || 0, az.xR || 0, az.zR || 0);
    aA.scale.set(aw / 2, ax / 2, ay / 2);
    if (az.src && !az.noGroup) {
      this.meshGroup(aA, az);
    } else {
      this.add(aA, az);
    }
    return aA;
  };
  var ap = [];
  this.addSpray = function (at, au, av, aw, ax, ay, az, aA) {
    aA = aA || {};
    a5 = null;
    for (var aB = 0; aB < ap.length; ++aB) {
      if (ap[aB].sid == at) {
        a5 = ap[aB];
        break;
      }
    }
    if (!a5) {
      true;
      (a5 = {}).sid = at;
      a5.is3D = !!aA.is3D;
      if (aA.is3D) {
        a5.mesh = this.loadMesh(
          {
            local: aA.local,
            src: "sprays/" + (aA.id || 0),
            opacity: aA.opacity,
            side: aA.doubleSide ? THREE.DoubleSide : THREE.FrontSide,
            transparent: aA.transparent || aA.opacity != 1,
            shadows: false,
            shadowsR: true,
            vertexColors: THREE.VertexColors,
            frames: aA.frames,
            frameT: aA.frameT,
            rgb: aA.rgb,
            rgbS: aA.rgbS,
            rgbT: aA.rgbT,
            sameGlow: aA.sameGlow,
            glowText: aA.glow || aA.sameGlow,
            emissive: aA.glow || aA.sameGlow ? 16777215 : null,
            pulsT: aA.pulsT,
            rAnim: aA.rAnim,
            rAnimA: aA.rAnimA,
            alphaTest: aA.alphaTest || 0,
          },
          av,
          aw,
          ax,
          [-90, 0, 0],
          aA.scl || 1,
          this.scene,
        );
      } else {
        a5.mesh = new THREE.Mesh(a3);
        a5.mesh.scale.set(Q.sprayScale, Q.sprayScale, 1);
        a5.mesh.receiveShadow = true;
        this.add(a5.mesh);
      }
      ap.push(a5);
    }
    if (a5.is3D) {
      if (a5.src != aA.src) {
        if (a5.mesh.material.map) {
          a5.mesh.material.map.dispose();
        }
        this.scene.remove(a5.mesh);
        a5.mesh = this.loadMesh(
          {
            local: aA.local,
            src: "sprays/" + (aA.id || 0),
            opacity: aA.opacity,
            side: aA.doubleSide ? THREE.DoubleSide : THREE.FrontSide,
            transparent: aA.transparent || aA.opacity != 1,
            shadows: false,
            shadowsR: true,
            vertexColors: THREE.VertexColors,
            frames: aA.frames,
            frameT: aA.frameT,
            rgb: aA.rgb,
            rgbS: aA.rgbS,
            rgbT: aA.rgbT,
            sameGlow: aA.sameGlow,
            glowText: aA.glow || aA.sameGlow,
            emissive: aA.glow || aA.sameGlow ? 16777215 : null,
            pulsT: aA.pulsT,
            rAnim: aA.rAnim,
            rAnimA: aA.rAnimA,
            alphaTest: aA.alphaTest || 0,
          },
          av,
          aw,
          ax,
          [0, 0, 0],
          (aA.scl || 1) * 4,
          this.scene,
        );
      }
    } else {
      a5.mesh.material = this.getMat("sprays/" + (aA.id || 0), {
        local: aA.local,
        depthWrite: false,
        opacity: aA.opacity,
        transparent: true,
        frames: aA.frames,
        frameT: aA.frameT,
        movT: aA.movT,
        movD: aA.movD,
        rgb: aA.rgb,
        rgbS: aA.rgbS,
        rgbT: aA.rgbT,
        sameGlow: aA.sameGlow,
        glowText: aA.glow || aA.sameGlow,
        emissive: aA.glow || aA.sameGlow ? 16777215 : null,
        pulsT: aA.pulsT,
        rAnim: aA.rAnim,
        rAnimA: aA.rAnimA,
      });
    }
    this.moveMesh(a5.mesh, av, aw, ax);
    a5.mesh.rotation.y = J.toRad((a5.is3D ? -90 : 0) + ay);
    a5.mesh.rotation.x = J.toRad(a5.is3D ? 0 : az);
  };
  this.clearSprays = function () {
    for (var at = 0; at < ap.length; ++at) {
      if (ap[at] && ap[at].mesh.material.map) {
        ap[at].mesh.material.map.dispose();
      }
      this.scene.remove(ap[at].mesh);
    }
    ap.length = 0;
  };
  this.addPlane = function (at, au, av, aw, ax, ay, az, aA, aB) {
    (ay = ay || {}).premultipliedAlpha = true;
    if (
      ay.noShader ||
      !this.ShaderMesh.enabled ||
      (ay.src && !ay.src.includes("default") && !ad[ay.src])
    ) {
      aC = new THREE.Mesh(GEOS.generatePlane(ax, aw, ay, at, au, av));
      if (ay.euler) {
        aC.rotation.order = ay.euler;
      }
      this.moveMesh(aC, at, au, av);
      aC.rotateY(az || 0);
      aC.rotateX((aA || 0) - Math.PI / 2);
      aC.rotateZ(aB || 0);
      aC.scale.set(aw * 2, ax * 2, 1);
      if (this.noTex) {
        ay.src = "default";
      }
      if (ay.dontAdd) {
        if (ay.src) {
          aC.material = this.getMat(ay.src, ay);
        }
      } else if (ay.src && !ay.noGroup) {
        this.meshGroup(aC, ay);
      } else {
        this.add(aC, ay);
      }
    } else {
      var aC = this.ShaderMesh.addPlane(at, au, av, aw, ax, ay, az, aA, aB);
    }
    return aC;
  };
  this.addGrass = function (at, au, av, aw, ax, ay, az) {
    az = az || {};
    let aA = new THREE.Geometry();
    let aB = Math.PI * 2 * Math.random();
    let aC = new THREE.Mesh(GEOS.generatePlane(aw, ax, az));
    aC.rotateY(aB * (Math.PI / 2));
    this.merge(aA, aC);
    let aD = new THREE.Mesh(GEOS.generatePlane(aw, ax, az));
    aD.rotateY((aB + 1) * (Math.PI / 2));
    this.merge(aA, aD);
    let aE = new THREE.Mesh(aA);
    this.moveMesh(aE, at, au + ax / 2, av);
    aE.rotation.set(az.yR || 0, az.xR || 0, az.zR || 0);
    aE.scale.set(aw, ax, ay);
    if (az.src && !az.noGroup) {
      this.meshGroup(aE, az);
    } else {
      this.add(aE, az);
    }
    return aE;
  };
  this.addRamp = function (at, au, av, aw, ax, ay, az, aA, aB) {
    aA = aA || {};
    var aC = new THREE.Mesh(GEOS.generatePlane(ay * 2, aw, aA));
    this.moveMesh(aC, at, au + ax / 2, av);
    ay *= 2;
    var aD = Math.sqrt(ax * ax + ay * ay);
    aC.scale.set(aw, aD, 2);
    aC.rotateY(-Math.PI / 2 - az);
    aC.rotateX(Math.asin(ax / aD) - Math.PI / 2);
    aC.rotateZ(aB || 0);
    if (this.noTex) {
      aA.src = "default";
    }
    if (aA.src && !aA.noGroup) {
      this.meshGroup(aC, aA);
    } else {
      this.add(aC, aA);
    }
    return aC;
  };
  var aq = [];
  var ar = [];
  this.loadMesh = function (at, au, av, aw, ax, ay, az, aA) {
    (at = at || {}).fileExt = at.fileExt || "obj";
    var aB = this.getMat(at.src, at);
    var aC = aq[at.src + at.fileExt];
    if (aC) {
      if (at.centerZ) {
        aC.computeBoundingBox();
        var aD = aC.boundingBox.getCenter();
        az.translateZ(aD.x * ay);
      }
    } else {
      aC = aA ? new THREE.Geometry() : new THREE.BufferGeometry();
      aq[at.src + at.fileExt] = aC;
      var aE = null;
      if (at.asset) {
        aE = function (aG) {
          af.updateProgress(((aG.loaded / aG.total) * 100).round(0));
        };
      }
      (at.fileExt == "gltf" ? a2 : a1).load(
        at.asset
          ? J.userAssetsUrl(at.src + "." + at.fileExt)
          : J.assetsUrl(
              "/models/" + at.src + "." + at.fileExt,
              false,
              at.localM,
            ),
        function (aG) {
          if (aG.scene) {
            aG = aG.scene;
          }
          var aH = aG.children[0].geometry;
          if (aG.children.length > 1) {
            var aI = new THREE.Geometry();
            for (var aJ = 0; aJ < aG.children.length; ++aJ) {
              aG.children[aJ].updateMatrix();
              aI.merge(
                new THREE.Geometry().fromBufferGeometry(
                  aG.children[aJ].geometry,
                ),
                aG.children[aJ].matrix,
                aJ,
              );
            }
            aI.groupsNeedUpdate = true;
            aH = new THREE.BufferGeometry().fromGeometry(aI);
          }
          aH = THREE.BufferGeometryUtils.mergeVertices(aH);
          if (at.asset) {
            aH.computeBoundingBox();
            var aK = aH.boundingBox.getCenter();
            aH.translate(0, -aK.y, 0);
          }
          aC.copy(aA ? new THREE.Geometry().fromBufferGeometry(aH) : aH);
          if (at.uv2) {
            aC.setAttribute(
              "uv2",
              new THREE.BufferAttribute(aC.attributes.uv.array, 2),
            );
          }
          if (aA) {
            var aL = new THREE.Geometry();
            for (aJ = 0; aJ < ar[at.src + at.fileExt].length; ++aJ) {
              af.merge(aL, ar[at.src + at.fileExt][aJ]);
            }
            af.add(
              new THREE.Mesh(new THREE.BufferGeometry().fromGeometry(aL), aB),
              at,
            );
            ar[at.src + at.fileExt].length = 0;
            ar[at.src + at.fileExt].loaded = true;
          }
          if (at.centerZ) {
            aC.computeBoundingBox();
            aK = aC.boundingBox.getCenter();
            az.translateZ(aK.x * ay);
          }
        },
        aE,
      );
    }
    var aF = new THREE.Mesh(aC, aB);
    aF.receiveShadow = !at.noShadow;
    aF.noGreen = at.noGreen;
    aF.castShadow = at.shadows;
    if (typeof ax == "object") {
      aF.rotation.x = aF.xR = ax[0] || 0;
      aF.rotation.y = aF.yR = ax[1] || 0;
      aF.rotation.z = aF.zR = ax[2] || 0;
    } else {
      aF.rotation.y = ax || 0;
    }
    aF.xP = au;
    aF.yP = av;
    aF.zP = aw;
    af.moveMesh(aF, au, av, aw);
    af.scaleMesh(aF, ay || 1, ay || 1, ay || 1);
    if (at.rAnim) {
      this.movMeshes.push({
        mesh: aF,
        tim: at.rAnim,
        axis: (at.rAnimA || "y").toUpperCase(),
      });
    }
    if (aA) {
      if (ar[at.src + at.fileExt]) {
        if (ar[at.src + at.fileExt].loaded) {
          this.meshGroup(aF, at);
        } else {
          ar[at.src + at.fileExt].push(aF);
        }
      } else {
        ar[at.src + at.fileExt] = [aF];
      }
    } else {
      az.add(aF);
    }
    return aF;
  };
  this.assetProgress = null;
  this.updateProgress = function (at) {
    if (!X) {
      af.assetProgress = "Loading " + at + "%";
      if (at >= 100) {
        af.assetProgress = null;
      }
      W.updatePlayInstructions();
    }
  };
  this.loadSprite = function (at, au) {
    var av = this.getMat(at.src, at);
    var aw = new THREE.Sprite(av);
    aw.yP = 0;
    aw.xP = 0;
    aw.zP = 0;
    aw.position.set(0, Q.playerHeight / 2, 0);
    aw.scale.set(Q.playerHeight, Q.playerHeight, 1);
    au.add(aw);
    return aw;
  };
  this.clearPendingMeshes = function () {
    for (var at in ar) {
      if (ar.hasOwnProperty(at) && ar[at]) {
        ar[at].length = 0;
      }
    }
  };
  this.updateMesh = function (at, au) {
    if (!at.toLowerCase().startsWith("event_0")) {
      var av = a1.parse(au);
      var aw = new THREE.BufferGeometry();
      aq[at + "obj"] = aw;
      aw.copy(av.children[0].geometry);
      aw.needsUpdate = true;
    }
  };
  this.merge = function (at, au, av) {
    au.updateMatrix();
    at.merge(au.geometry, au.matrix, av);
  };
  this.genObj3D = function (at, au, av) {
    var aw = new THREE.Object3D();
    this.moveMesh(aw, at || 0, au || 0, av || 0);
    return aw;
  };
  this.meshGroup = function (at, au) {
    var av =
      (this.noTex && !au.forceTex ? "default" : au.src) +
      "-" +
      (au.shadowsR || "a") +
      (au.emissive || "e") +
      (au.opacity || "o") +
      (au.movT == null ? "mt" : au.movT) +
      (au.movD == null ? "md" : au.movD) +
      (au.showAd ? "sad" : "nad") +
      (au.texOffX || "tox") +
      (au.texOffY || "toy") +
      (au.normal || "n") +
      (au.specular || "spec") +
      (au.asset || "as") +
      (au.itemID || "itemID");
    if (!ag[av]) {
      ag[av] = new THREE.Geometry();
      ag[av].data = au;
    }
    at.updateMatrix();
    ag[av].merge(at.geometry, at.matrix);
  };
  this.addMeshGroups = function () {
    for (var at in ag) {
      if (ag.hasOwnProperty(at)) {
        var au = new THREE.Mesh(
          THREE.BufferGeometryUtils.mergeVertices(
            new THREE.BufferGeometry().fromGeometry(ag[at]),
          ),
        );
        au.groupSrc = ag[at].data.src;
        au.visible = !as[au.groupSrc];
        au.matrixAutoUpdate = false;
        this.add(au, ag[at].data);
      }
    }
    ag = {};
  };
  this.finalizeInstanceGroups = function () {
    if (this.ShaderMesh.enabled) {
      this.ShaderMesh.finalize(aa, this);
    }
  };
  this.clearInstances = function () {
    if (this.ShaderMesh.CUBES.mesh) {
      af.scene.remove(this.ShaderMesh.CUBES.mesh);
    }
    if (this.ShaderMesh.PLANES.mesh) {
      af.scene.remove(this.ShaderMesh.PLANES.mesh);
    }
  };
  var as = {};
  this.toggleMeshGroup = function (at, au) {
    as[at] = !au;
    if (this.scene) {
      this.scene.traverse(function (av) {
        if (av instanceof THREE.Mesh && (av.groupSrc == at || av.dSrc == at)) {
          av.visible = au;
        }
      });
    }
  };
  this.add = function (at, au) {
    if (au) {
      at.castShadow = au.shadows;
      at.receiveShadow = au.shadows || au.shadowsR;
      at.material = this.getMat(
        this.noTex && !au.forceTex ? "default" : au.src,
        au,
      );
      at.dSrc = au.src;
    }
    this.scene.add(at);
    this.updateShadowMap();
  };
  this.remove = function (at) {
    this.scene.remove(at);
  };
  this.moveMesh = function (at, au, av, aw) {
    if (at) {
      if (au != null) {
        at.position.x = au;
      }
      if (av != null) {
        at.position.y = av;
      }
      if (aw != null) {
        at.position.z = aw;
      }
    }
  };
  this.scaleMesh = function (at, au, av, aw) {
    at.scale.set(au, av, aw);
  };
  this.rotateMesh = function (at, au, av, aw) {
    if (at) {
      if (au || au == 0) {
        at.rotation.y = au;
      }
      if (av || av == 0) {
        at.rotation.x = av;
      }
      if (aw || aw == 0) {
        at.rotation.z = aw;
      }
    }
  };
  this.reset = function () {
    ar = [];
    ag = {};
    a6 = {};
    a7 = {};
    a8 = {};
    aq = [];
    instances.length = 0;
    this.movTextures.length = 0;
    this.movMeshes.length = 0;
    this.frameMats.length = 0;
    this.rgbMats.length = 0;
    this.pulsMats.length = 0;
    this.pulsVal = 0;
    this.liquidVal = 0;
    this.liquids.length = 0;
  };
};
module.exports.initScene = function (p, q) {
  p;
  q;
  if ((q && q.ambCol != null) || p.ambient) {
    this.ambientLight = new THREE.AmbientLight(
      q && q.ambCol != null ? q.ambCol : p.ambient,
      p.ambientI == null ? config.ambIntensity : p.ambientI,
    );
    this.ambientLight.layers.enable(1);
    this.ambientLight.layers.enable(2);
    this.ambientLight.name = "ambLight";
    if (!this.scene.getObjectByName("ambLight")) {
      this.scene.add(this.ambientLight);
    }
  }
  if ((q && q.lightCol != null) || p.light) {
    this.skyLight = new THREE.DirectionalLight(
      q && q.lightCol != null ? q.lightCol : p.light,
      p.lightI == null ? config.lightIntensity : p.lightI,
    );
    this.skyLight.name = "skyLight";
    this.skyLight.layers.enable(1);
    this.skyLight.layers.enable(2);
    if (!this.scene.getObjectByName("skyLight")) {
      this.scene.add(this.skyLight);
    }
    var u =
      Math.PI * ((p.sunAngY == null ? config.sunAngleY : p.sunAngY) / -180);
    var v =
      Math.PI * ((p.sunAngX == null ? config.sunAngleX : p.sunAngX) / -180);
    var w = p.lightD == null ? config.lightDistance : p.lightD;
    this.skyLight.position.x = w * Math.cos(v);
    this.skyLight.position.y = w * Math.sin(v) * Math.sin(u);
    this.skyLight.position.z = w * Math.sin(v) * Math.cos(u);
    this.skyLight.castShadow = true;
    var x = this.highResShad ? 4096 : p.shadowR || config.shadowRes;
    this.skyLight.shadow.mapSize.width = x;
    this.skyLight.shadow.mapSize.height = x;
    this.skyLight.shadow.camera.far = p.shadowD || config.shadowDst;
    this.skyLight.shadow.bias = -0.0004;
  }
  this.scene.fog = new THREE.Fog(
    q && q.fogC != null ? q.fogC : p.fog,
    1,
    q && q.fogD != null ? q.fogD : p.fogD,
  );
  if (this.renderer) {
    this.renderer.setClearColor(q && q.skyCol != null ? q.skyCol : p.sky);
  }
};
module.exports.regenSky = function (p, q) {
  this.renderer.setClearColor(q && q.skyCol != null ? q.skyCol : p.sky);
};
